import * as bowser from 'bowser';

const browser = bowser.getParser(window.navigator.userAgent);
const osInfo = browser.getOS();

export function getPathSeparator(): string {
  if (osInfo && osInfo.name === 'Windows') {
    return '\\';
  }
  return '/';
}
